// extracted by mini-css-extract-plugin
export default {"container":"bandwidth_input_container__ezlEJ","bandwidthDisplay":"bandwidth_input_bandwidthDisplay__QI11U","listItem":"bandwidth_input_listItem__0+fqi"};